import React, { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import {
    Box,
    IconButton,
    Snackbar,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import * as selectors from './selectors';

const Container = ({
    fetchVersion,
    hasNewVersionAvailable,
    location,
    setNewVersionAvailable,
}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const route = location.pathname;

    useEffect(() => {
        fetchVersion();
    }, [route]);

    useEffect(() => {
        if (hasNewVersionAvailable) setOpen(true);
    }, [hasNewVersionAvailable]);

    const handleClose = () => {
        setNewVersionAvailable(false);
        setOpen(false);
    };

    const handleReload = () => {
        setNewVersionAvailable(false);
        window.location.reload();
        setOpen(false);
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            action={
                <IconButton
                    color="inherit"
                    size="small"
                    onClick={() => handleClose()}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
            open={open}
            message={
                <Box display="flex" onClick={() => handleReload()}>
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            p: 0.5,
                            width: '38px',
                        }}
                    >
                        <NewReleasesIcon sx={{ color: '#fff' }} />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 0.5,
                        }}
                    >
                        <Typography fontWeight="bold" variant="caption">
                            {t('A new version was released')}.
                        </Typography>
                        <Typography variant="caption">
                            {t('Improvements to offer you a better service')}
                        </Typography>
                        <Typography variant="caption">
                            {t('Click here to update')}
                        </Typography>
                    </Box>
                </Box>
            }
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: '#0047ba',
                    color: '#fff',
                },
            }}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    hasNewVersionAvailable: selectors.getHasNewVersionAvailable,
});

const mapDispatchToProps = (dispatch) => ({
    fetchVersion: () => dispatch(actions.fetchVersion()),
    setNewVersionAvailable: (value) =>
        dispatch(actions.setNewVersionAvailable(value)),
});

Container.propTypes = {
    fetchVersion: PropTypes.func,
    hasNewVersionAvailable: PropTypes.bool,
    location: PropTypes.object,
    setNewVersionAvailable: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Container));
